import {Button, Dialog, DialogActions, DialogTitle} from "@mui/material";
import React from "react";
import useModalState from "../../../../stores/useModalStore";
import EditContactDialogContent from "./EditContactDialogContent";
import useContactsStore from "../../../../stores/useContactsStore";
import usePostChangeQuery from "../../../../../../global/queries/usePostChangeQuery";
import {contactValidation} from "../../../../validations/contactValidation";
import * as Yup from "yup";
import {useSnackbar} from "notistack";

export default function EditContactDialog() {

    const {getContactChanges, currentContact} = useContactsStore();
    const {isEditContactDialogOpen, toggleIsEditContactDialogOpen} = useModalState();
    const postChangeQuery = usePostChangeQuery();

    const {enqueueSnackbar} = useSnackbar();


    const saveKontakt = async () => {

        try {
            await contactValidation.validate(currentContact, {abortEarly: false})
            console.log("Current Contact: ", currentContact)
            const changes = getContactChanges();
            console.log("ContactChanges: ", changes)
            changes.forEach(change => postChangeQuery.mutate(change))
            toggleIsEditContactDialogOpen();
        } catch (error) {
            if (error instanceof Yup.ValidationError && error.errors) {
                error.errors.forEach((errorMessage) => {
                    enqueueSnackbar(`Validierungsfehler: ${errorMessage}`, {variant: "error"});
                });
            }
        }

    }

    return (
        <>
            <Dialog
                open={isEditContactDialogOpen}
                onClose={toggleIsEditContactDialogOpen}>
                <DialogTitle sx={{backgroundColor: "secondary.main", padding: "8px 24px"}}>Kontakt
                    bearbeiten</DialogTitle>
                <EditContactDialogContent/>
                <DialogActions>
                    <Button onClick={saveKontakt}
                            variant="contained">
                        Speichern
                    </Button>
                    <Button onClick={() => {
                        toggleIsEditContactDialogOpen()
                    }}
                            variant="contained">
                        Verwerfen
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )

}
